"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.up = exports.only = exports.media = exports.isMobile = exports.isMediumUp = exports.isDesktop = exports.down = exports.defaultCarouselBreakpoints = exports["default"] = exports.between = exports.SCREEN_SIZE = void 0;
var _styledComponents = require("styled-components");
var _constants = require("./constants");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var breakpoints = {
  xs: _constants.BREAKPOINTS.xs,
  sm: _constants.BREAKPOINTS.sm,
  md: _constants.BREAKPOINTS.md,
  lg: _constants.BREAKPOINTS.lg,
  xl: _constants.BREAKPOINTS.xl
};
var SCREEN_SIZE = exports.SCREEN_SIZE = {
  EXTRA_SMALL: 'xs',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  EXTRA_LARGE: 'xl'
};
var between = exports.between = function between(label) {
  return "".concat(label, "Between");
};
var down = exports.down = function down(label) {
  return "".concat(label, "Down");
};
var only = exports.only = function only(label) {
  return "".concat(label, "Only");
};
var up = exports.up = function up(label) {
  return "".concat(label, "Up");
};

// Iterate through the sizes and create a media template
var media = exports.media = Object.entries(breakpoints).reduce(function (acc, _ref, index, array) {
  var _objectSpread2;
  var _ref2 = _slicedToArray(_ref, 2),
    label = _ref2[0],
    value = _ref2[1];
  var nextBreakpointValue = index + 1 < array.length ? array[index + 1][1] : '';
  var betweenMediaQuery = function betweenMediaQuery() {
    return (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      @media (min-width:", "px) ", " {\n        ", "\n      }\n    "])), value, nextBreakpointValue ? "and (max-width:".concat(nextBreakpointValue, "px)") : '', _styledComponents.css.apply(void 0, arguments));
  };
  var downMediaQuery = function downMediaQuery() {
    return (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      @media (", ") {\n        ", "\n      }\n    "])), nextBreakpointValue ? "max-width:".concat(nextBreakpointValue - 0.05, "px") : 'min-width:0px', _styledComponents.css.apply(void 0, arguments));
  };
  var onlyMediaQuery = function onlyMediaQuery() {
    return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      @media (min-width:", "px) ", " {\n        ", "\n      }\n    "])), value, nextBreakpointValue ? "and (max-width:".concat(nextBreakpointValue - 0.05, "px)") : '', _styledComponents.css.apply(void 0, arguments));
  };
  var upMediaQuery = function upMediaQuery() {
    return (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      @media (min-width:", "px) {\n        ", "\n      }\n    "])), value, _styledComponents.css.apply(void 0, arguments));
  };
  return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, between(label), betweenMediaQuery), _defineProperty(_objectSpread2, down(label), downMediaQuery), _defineProperty(_objectSpread2, only(label), onlyMediaQuery), _defineProperty(_objectSpread2, up(label), upMediaQuery), _objectSpread2));
}, {});
var defaultCarouselBreakpoints = exports.defaultCarouselBreakpoints = {
  arrows: true,
  responsive: [{
    breakpoint: breakpoints.sm,
    settings: {
      arrows: false
    }
  }]
};
var isMobile = exports.isMobile = function isMobile(width) {
  return width === 'xs';
};
var isMediumUp = exports.isMediumUp = function isMediumUp(width) {
  return width === 'md' || width === 'lg' || width === 'xl';
};
var isDesktop = exports.isDesktop = function isDesktop(width) {
  return width === 'lg' || width === 'xl';
};
var _default = exports["default"] = breakpoints;